export default __webpack_public_path__ + "static/media/banner-mid.0cdfecc9.webp";